// extracted by mini-css-extract-plugin
export var container = "HomeAbout-module--container--QJ1iT";
export var image = "HomeAbout-module--image--Czsua";
export var lineLink = "HomeAbout-module--line-link--Mg-PG";
export var lineLink_black = "HomeAbout-module--line-link_black--5IQLI";
export var lineLink_grey = "HomeAbout-module--line-link_grey--y45nX";
export var lineLink_primary = "HomeAbout-module--line-link_primary--WG-BO";
export var lineLink_secondary = "HomeAbout-module--line-link_secondary--tUM5l";
export var lineLink_white = "HomeAbout-module--line-link_white--9D6aE";
export var txt = "HomeAbout-module--txt--6E8kw";